import Icon from 'veui/components/Icon'
import { IconExclamationCircle } from 'dls-icons-vue'

Icon.register('exclamation-circle', IconExclamationCircle)
